import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { useApp } from "@/lib/store";
import { CheckCircle, XCircle, Loader2, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

export default function VerifyEmailPage() {
  const { token } = useParams();
  const { t } = useApp();
  const [status, setStatus] = useState("loading"); // loading | ok | error

  useEffect(() => {
    let mounted = true;
    api.get(`/auth/verify-email/${token}`)
      .then(() => mounted && setStatus("ok"))
      .catch(() => mounted && setStatus("error"));
    return () => { mounted = false; };
  }, [token]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5 relative z-[1]">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="lux-surface p-10 text-center max-w-md w-full"
      >
        {status === "loading" && (
          <>
            <Loader2 className="w-12 h-12 text-[#D4B483] animate-spin mx-auto mb-5" />
            <p className="text-[#D4D4D8]">{t("Verifierar din e-post...")}</p>
          </>
        )}
        {status === "ok" && (
          <>
            <CheckCircle className="w-14 h-14 text-[#10B981] mx-auto mb-5" />
            <h1 className="font-playfair text-3xl text-[#F5F1E8] mb-2 lux-title">{t("E-post bekräftad!")}</h1>
            <p className="text-[#D4D4D8] mb-7">{t("Tack! Din e-postadress är nu verifierad.")}</p>
            <Link to="/menu" className="btn-lux inline-flex items-center gap-2 rounded-full bg-[#D4B483] text-[#0A0A0A] px-7 py-3.5 text-sm font-bold tracking-[0.08em] uppercase hover:bg-[#E5CFA5] transition-colors">
              {t("Utforska menyn")} <ArrowRight className="w-4 h-4 relative z-[2]" />
            </Link>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="w-14 h-14 text-[#EF4444] mx-auto mb-5" />
            <h1 className="font-playfair text-3xl text-[#F5F1E8] mb-2 lux-title">{t("Länken är ogiltig")}</h1>
            <p className="text-[#D4D4D8] mb-7">{t("Länken kan ha gått ut eller redan använts. Begär en ny från din profil.")}</p>
            <Link to="/profile" className="inline-flex items-center gap-2 text-[#D4B483] hover:text-[#E5CFA5] text-sm font-semibold uppercase tracking-[0.1em]">
              {t("Till profilen")} <ArrowRight className="w-4 h-4" />
            </Link>
          </>
        )}
      </motion.div>
    </div>
  );
}
